/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedWheelchairIcon24Solid = forwardRef('MedWheelchairIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.325 6.98a3.167 3.167 0 1 0-2.498.18l.851 6.612a1.98 1.98 0 0 0 1.965 1.728h5.6l2.42 4.638a1.75 1.75 0 0 0 2.35.748l1.808-.928a1.25 1.25 0 0 0-1.14-2.225l-1.147.588-2.22-4.256A1.98 1.98 0 0 0 16.556 13h-5.458l-.29-2.25h4.616a1.25 1.25 0 0 0 0-2.5h-4.937l-.163-1.27Z" }),
        React.createElement("path", { d: "M6.276 11.3a1.25 1.25 0 0 0-1.552-1.96 7.828 7.828 0 1 0 11.43 10.39 1.25 1.25 0 1 0-2.1-1.36 5.328 5.328 0 1 1-7.78-7.07Z" })));
});
